import React from 'react';
import ConfirmIcon from '../../../images/icon-confirm.svg';
import CloseICon from '../../../images/icon-close.svg';
import styles from './createVisitorForm.module.css';
import { useNavigate } from 'react-router-dom';
import { IVisitorPopup } from '../interface/Visitor.interface';

const VisitorPopup = ({ message, title, setShowModalPopup }: IVisitorPopup) => {
    const navigate = useNavigate();

    return (
        <div className={styles.modalOuter}>
            <img
                onClick={() => {
                    navigate('/visitor');
                    setShowModalPopup(false);
                }}
                src={CloseICon}
                alt="close-icon"
                className={styles.closeIcon}
            />
            <div className={styles.modalHeader}>
                <img src={ConfirmIcon} alt="confirm icon" />
            </div>
            <div className={styles.modalBody}>
                <h2>{title}</h2>
                <p>{message} </p>
            </div>

            <div className={styles.btnContainer}>
                <button
                    onClick={() => {
                        navigate('/visitor');
                        setShowModalPopup(false);
                    }}
                    className={styles.btnGreen}>
                    Take me there
                </button>
            </div>
        </div>
    );
};

export default VisitorPopup;
